export default __webpack_public_path__ + "static/880-cb0c5f3195f0bed7ef3c72696b1b137a.gif";